import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { FormComponentComponent } from 'src/app/components/form-component/form-component.component';
import { YappyComponent } from 'src/app/components/yappy/yappy.component';
import { Types } from 'src/app/constants/gift-card-type';
import { BalanceService } from 'src/app/services/balance.service';
import { FormServices } from 'src/app/services/form-services.service';
import { HttpService } from 'src/app/services/http.service';
import { LoginService } from 'src/app/services/login.service';
import { ParamServicesService } from 'src/app/services/param-services.service';
import { StripeService } from 'src/app/services/stripe.service';
import { UiServices } from 'src/app/services/ui-services';
import { environment } from 'src/environments/environment';
import { PagueloFacilComponent } from '../paguelo-facil/paguelo-facil.component';
import { GiftCardService } from 'src/app/services/gift-card.service';
import { PagoMovilComponent } from '../pago-movil/pago-movil.component';

declare var grecaptcha: any;

@Component({
  selector: 'app-method',
  templateUrl: './method.component.html',
  styleUrls: ['./method.component.scss'],
})
export class MethodComponent implements OnInit, OnDestroy {
  @ViewChild('typePaymentForm')
  typePaymentForm: FormComponentComponent;
  @ViewChild('selectTypePay')
  selectTypePay: FormComponentComponent;
  @ViewChild('yappy') yappy: YappyComponent;
  @ViewChild('pagueloFacil') pagueloFacil: PagueloFacilComponent;
  @ViewChild('pagoMovil') pagoMovil: PagoMovilComponent;
  @Input() set dataPayment(value) {
    this.data = value;
    if (this._userGiftCards) {
      this._userGiftCards = this._userGiftCards.map((item) => {
        if (item.percentage) {
          const totalAmount = Number(this.totalWithTax || this.data?.amount);
          if (item.minimumAmount) {
            item.minimumAmount = (totalAmount * item.percentage) / 100;
          } else {
            item.price = (totalAmount * item.percentage) / 100;
          }
        }
        return item;
      });
    }
  }
  @Input() cart: any = undefined;
  @Input() list: any[] = [];
  @Input() payment: any = undefined;
  @Input() paramDispatch: any = undefined;
  @Input() transactionData: any = undefined;
  @Input() showGiftCards = true;
  @Input() nameClient: string = undefined;
  @Output() close = new EventEmitter();

  public data = undefined;
  public currency: any;
  public methods: any[] = [];
  public backupMethods: any[] = [];
  public typeId = undefined;
  public typePayments: any[] = undefined;
  public typePayment: any[] = undefined;
  public currencyName: string = 'USD';
  public message: string = '';
  public token = undefined;
  public tax = 0;
  public percent = 0;
  public totalWithTax = 0;
  public openFacil = false;
  public giftCardAndCouponAdded = 0;

  private _domainId = environment.domainId;
  private _userGiftCards: any[] = undefined;
  private _currencyObs: Subscription = undefined;
  private _typeOfUseAux = null;

  private _auxGiftCardSelectedInOrder = [];

  private _giftCardSubs: Subscription = undefined;

  constructor(
    public balanceSv: BalanceService,
    public loginSv: LoginService,
    public paramSv: ParamServicesService,
    public giftCardSv: GiftCardService,
    private httpSv: HttpService,
    private uiSv: UiServices,
    private formSv: FormServices,
    private stripeSv: StripeService,
    private translateSv: TranslateService
  ) {}

  async ngOnInit() {
    try {
      this._giftCardSubs = this.giftCardSv.giftCardAndCouponsAmount$.subscribe(
        (giftCardId) => {
          this.checkGiftCard({ id: giftCardId });
        }
      );

      this._currencyObs = this.balanceSv.currencySource.subscribe(
        (currency) => {
          this.currency = currency;
        }
      );
      if (this.data) {
        this.data.amount = this.data?.amount || this.payment;
      }
      this.totalWithTax = this.data?.amount || this.payment || 0;
      if (this.balanceSv.currency) {
        this.currency = this.balanceSv.currency;
        this.currencyName =
          this.currency.symbol || this.balanceSv.currencyBaseName;
      }
      const methods: any = await this.httpSv.itemIndex(
        'client/banks',
        this._domainId
      );

      this.methods = methods.data.filter(
        (bank) =>
          bank?.name !== 'PagueloFacil' &&
          bank?.name !== 'Yappy' &&
          bank?.name !== 'bancoGeneral' &&
          bank?.name !== 'stripe'
      );
      this.backupMethods = this.methods;
      const paymentForm: any[] = await this.formSv.getForm(
        'typePay',
        this._domainId
      );

      this.typePayments = paymentForm;
      this.setPriceOfGiftCard();
      if (this.transactionData?.reason === 'payCredit') {
        const wpp = this.paramSv.numWpp;
        this.typePayments[0].select = this.typePayments[0].select.filter(
          (item) => item.id !== 'credit'
        );
        window.open(`https://wa.me/${wpp}`, '_blank');
      } else if (this.transactionData?.reason === 'Recarga') {
        this.typePayments[0].select = this.typePayments[0].select.filter(
          (item) => item.id !== 'wallet'
        );
      }
    } catch (err) {
      console.error(err);
    }
  }

  setPriceOfGiftCard() {
    for (const item of this.typePayments) {
      if (item.fieldName === 'userGiftCard') {
        const priceToPay = this.totalWithTax || this.data?.amount;
        this._userGiftCards = item.select;
        if (this._userGiftCards) {
          this._userGiftCards = this._userGiftCards.sort((a, b) => {
            return a.typeOfConsumption - b.typeOfConsumption;
          });
          this._userGiftCards = this._userGiftCards
            .filter((item) => {
              return (
                !item.productId ||
                !!this.list?.find((x) => item.productId === x.productId)
              );
            })
            .map((item) => {
              if (item.percentage) {
                item.price = (priceToPay * item.percentage) / 100;
              }
              return item;
            });
        }
        item.select = this._userGiftCards;
        if (item.select) {
          for (const card of item.select) {
            if (
              card.typeOfConsumption === Types.GIFT_CARD &&
              card.price - card.amount_used > this.data?.amount
            ) {
              card.disable = true;
            }
          }
        }
      }
    }
  }

  ngOnDestroy(): void {
    this._currencyObs.unsubscribe();
    this._giftCardSubs.unsubscribe();
  }

  finish(newUrl?: string) {
    if (this.typePaymentForm) {
      this.typePaymentForm.submitInfo(newUrl);
    } else {
      this.continue(new FormData());
    }
  }

  async getSelect(idBank) {
    const receivingBank = this.typePayment.find(
      (x) => x.fieldName === 'receivingBank'
    );
    if (receivingBank) {
      const bank = this.methods.find((x) => x.name === idBank);
      const tax = bank.tax;
      this.calcTax(tax);
    }
  }

  async calcTax(tax) {
    const price = this.data?.amount || this.payment;
    this.totalWithTax = price;
    this.tax = tax;
    this.percent = +((price * this.tax) / 100).toFixed(2);
    this.totalWithTax = Number(price) + this.percent;
    this.setPriceOfGiftCard();
    if (tax) {
      let msgToTranslate = 'SE_COBRARA_UN_MONTO_ADICIONAL_SOBRE_EL_TOTAL_DEL';
      if (this.typeId === 'stripe') {
        msgToTranslate =
          'SE_COBRARA_UN_MONTO_ADICIONAL_SOBRE_EL_TOTAL_DEL_STRIPE';
      }
      const msg = this.translateSv.instant(msgToTranslate, {
        tax,
      });

      await this.uiSv.presentAlert(
        `${this.typeId} - ${this.paramDispatch?.comissionType || msg}`,
        false
      );
    }
  }

  checkGiftCard(ev) {
    try {
      const card = this._userGiftCards.find(
        (giftCard) => giftCard.id === ev.id
      );

      this._typeOfUseAux = card.typeOfUse;

      const existTypeOfUseSelected = this._userGiftCards.filter(
        (x) => x.typeOfUse === this._typeOfUseAux && x.checked
      );

      if (!existTypeOfUseSelected.length) {
        this._typeOfUseAux = card.typeOfUse;
        this._userGiftCards.forEach((item) => {
          item.disable = false;
        });
      }

      const disableGiftCard = (property) => {
        this._userGiftCards
          .filter((item) => item[property] !== card[property])
          .forEach((item) => {
            item.disable = true;
          });
      };

      if (card.checked) {
        if (card.typeOfUse === 2) {
          disableGiftCard('id');
        } else {
          disableGiftCard('typeOfUse');
        }

        if (!this._auxGiftCardSelectedInOrder.find((x) => x.id === card.id)) {
          this._auxGiftCardSelectedInOrder.push(card);
        }
      } else {
        const indexOf = this._auxGiftCardSelectedInOrder.findIndex(
          (x) => x.id === card.id
        );
        if (indexOf != -1) {
          this._auxGiftCardSelectedInOrder.splice(indexOf, 1);
        }
      }

      const amountSelectedCompleteUseGiftCards = this._userGiftCards
        .filter(
          (item) => item.checked && item.typeOfConsumption === Types.GIFT_CARD
        )
        .reduce((a, b) => {
          return (a += b.price);
        }, 0);

      this.giftCardAndCouponAdded = this._userGiftCards
        .filter((item) => item.checked)
        .reduce((a, b) => {
          const amountUsed = b.price - b.amount_used;
          return (a += amountUsed);
        }, 0);

      setTimeout(() => {
        if (this.giftCardAndCouponAdded >= Number(this.data.amount)) {
          this.typeId = 'Gift Card / Cupon';
          this.selectTypePay.dinamicForm.get('typePay').setValue('');
          this.selectTypePay.dinamicForm.get('typePay').disable();
        } else {
          this.selectTypePay.dinamicForm.get('typePay').enable();
        }
      }, 0);

      if (amountSelectedCompleteUseGiftCards > Number(this.data.amount)) {
        const tr = this.translateSv.instant(
          'EL_MONTO_EN_CUPON_SUPERA_EL_MONTO_DE_LA_COMPRA'
        );
        this.uiSv.presentAlert(tr, false);
        ev.checkbox.checked = false;
      }
    } catch (error) {
      console.error('error :>> ', error);
    }
  }

  async setTypePay(name) {
    this.openFacil = false;
    try {
      const typeCredit = this.loginSv?.user?.creditType;
      this.typePayment = undefined;
      if (typeCredit && typeCredit === 'disable' && name === 'credit') {
        const tr = this.translateSv.instant(
          'PUEDES_OBTENER_UN_CREDITO_COMUNICANDOTE_CON_EL_ADMINISTRADOR'
        );
        const { role } = await this.uiSv.presentAlert(tr);
        if (role === 'accept') {
          const wpp = this.paramSv.numWpp;
          window.open(
            `https://wa.me/${wpp}?text=Hola quiero informacion de como obtener un credito.`,
            '_blank'
          );
        } else {
          name = undefined;
        }
        return;
      }
      const typePayForm = this.typePayments.find(
        (x) => x.fieldName === 'typePay'
      );
      const typePay = typePayForm.select.find((x) => x.id === name);
      this.typeId = name;
      this.calcTax(typePay.tax || 0);
      if (this.typeId === 'zelle') {
        this.methods = this.backupMethods.filter(
          (item) => item.name.toLowerCase() === 'zelle'
        );
      } else if (this.typeId === 'payment') {
        this.methods = this.backupMethods.filter(
          (item) => item.name.toLowerCase() !== 'zelle'
        );
      }
      const paymentForm: any = await this.formSv.getForm(name, this._domainId);
      this.typePayment = paymentForm;
      this.message = this.paramDispatch?.paymentsType?.find(
        (item) => item.id === name
      )?.value;
      //}
    } catch (err) {
      console.error(err);
    }
  }

  payWithStripe() {
    this.stripeSv.sendData.emit();
  }

  async continue(data: FormData | any, newUrl?: string) {
    if (this.typePayments.find((item) => item.typeInput === 'captcha')) {
      if (typeof grecaptcha !== 'undefined') {
        grecaptcha.ready(() => {
          grecaptcha
            .execute(environment.captchaKey, {
              action: 'submit',
            })
            .then((token) => {
              this.handleContinue(data, newUrl, token);
              // Add your logic to submit to your backend server here.
            });
        });
      } else {
        this.handleContinue(data, newUrl);
      }
    } else {
      this.handleContinue(data, newUrl);
    }
  }

  async handleContinue(
    data: FormData | any,
    newUrl?: string,
    recaptchaToken?: string
  ) {
    try {
      if (data?.value === false) {
        return false;
      }
      await this.uiSv.showLoading();
      this.transactionData
        ? data.set('transactionId', this.transactionData?.transactionId)
        : data.set('orderId', this.data.id);

      if (recaptchaToken) {
        data.set('recaptchaToken', recaptchaToken);
      }

      if (this.transactionData?.reason === 'payCredit') {
        data.set('description', this.transactionData.reason);
      } else if (this.transactionData?.reason === 'renew') {
        data.set(
          'inscriptionId',
          this.transactionData.inscriptionId || this.transactionData?.id
        );
        data.set('isClient', this.transactionData.isClient);
      }

      if (this._userGiftCards) {
        const giftIds = this._auxGiftCardSelectedInOrder.map((item) => {
          return item.id;
        });
        data.set('userGiftCardId', JSON.stringify(giftIds));
      }

      data.set(
        'amount',
        this.totalWithTax || this.payment || this.data?.amount
      );
      // data.set('discount', this.loginSv.user?.customerDiscount?.discount || 0);
      data.set('type', this.typeId);
      this.cart += `Pago: %0A`;

      if (this.typeId === 'stripe') {
        data.set('currency', this.paramSv.defaultCurrency?.symbol);
      } else if (this.typeId === 'credit') {
        this.cart += 'Credito';
      } else if (this.typeId === 'bancoGeneral') {
        data.set(
          'currency',
          this.balanceSv.currency.symbol || this.balanceSv.currencyBaseName
        );
      } else if (this.typeId === 'yappy') {
        this.cart += 'Yappy';
      } else if (this.typeId === 'paguelofacil') {
        this.cart += 'Paguelo Facil';
      } else if (this.typeId === 'pagomovil') {
        this.cart += 'Pago Movil';
      }

      if (this.tax) {
        data.set('methodsTax', this.percent);
        data.set('methodsTaxPercentage', this.tax);
      }

      if (this.typeId === 'pagomovil') {
        await this.pagoMovil.sendData();
      }

      //DEFINO SI EL USUARIO EXISTE PARA ENVIAR AL API O NO
      const route = this.loginSv.user ? 'purchase/payment' : 'unSave/payment';
      data.set('domainId', this._domainId.toString());
      const res: any = await this.httpSv.itemAction(data, route, 'store');
      await this.uiSv.loading.dismiss();

      if (!res.status && this.typeId === 'wallet') {
        const tr = this.translateSv.instant(
          'NO_TIENES_SALDO_SUFICIENTE_EN_TU_WALLET_RECARGA_ANTES_PARA_CONTINUAR_CON_TU_COMPRA'
        );
        await this.uiSv.presentAlert(tr);
        return false;
      } else if (!res.status && this.typeId === 'credit') {
        await this.uiSv.presentAlert(res.mensage);
        return false;
      }

      this.typePayment?.map((item) => {
        this.cart += `${item.labelValue}: ${data.get(item.fieldName)}%0A`;
      });
      const paymentType = data.get('extraData');
      if (paymentType) {
        if (paymentType === 'yappy') {
          const crypted = btoa(this.cart);
          this.yappy.payment.successUrl += `&cart=${crypted}`;
          await this.yappy.sendPayment();
          return;
        } else {
          this.cart += `%0AMonto: ${this.totalWithTax.toFixed(2)}%0A`;
          const crypted = btoa(this.cart);
          await this.pagueloFacil.sendPayment(crypted);
          return;
        }
      }

      this.close.emit({ text: 'sended', cart: this.cart });
    } catch (err) {
      await this.uiSv.loading.dismiss();
      if (this.typeId === 'stripe') {
        this.stripeSv.reportError(err.error);
      } else if (this.typeId === 'bancoGeneral') {
        await this.uiSv.showToast('Su pago no ha sido procesado');
        return;
      }
      console.error(err);
      const translate = this.translateSv.instant('HA_OCURRIDO_UN_ERROR');
      await this.uiSv.showToast(translate);
    }
  }
}
